<template>
  <div class="p-4">
    <h4>{{ chartRoute.title }}</h4>
    <p>A dozen different offshore firms provided services to 336 politicians identified in the investigation.</p>
    <stacked-bar-chart
      :data="tsv"
      :social-mode="socialMode"
      :fixed-height="fixedHeight"
      hide-legend
      class="mt-4" />
    <p class="text-muted mt-2 small text-right">Source: Pandora Papers data</p>
    <p class="mt-2 font-italic">Some politicians received offshore services from more than one firm.<p/>
  </div>
</template>

<script>
import chart from '../mixins/chart'
import { sortBy } from 'lodash'

export default {
  mixins: [chart],
  name: 'ChartPoliticiansForEachProvider',
  computed: {
    tsv () {
      return sortBy(this.$options.tsv, ({ value }) => -value)
    }
  }
}
</script>

<tsv>
label	value
Alcogal	161
Cititrust	3
Trident Trust	97
Asiaciti Trust	25
Fidelity	10
OMC Group	21
SFM	18
Alpha	11
AABOL	8
Commence BVI	4
GDG	2
DADLAW	17
</tsv>
